export default __webpack_public_path__ + "static/media/btn-googleplay.a431a10f.png";